<template>
    <div class="addCompaniesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>
        <div v-else class="row">
            <div class="col-md-7">
                <v-form ref="form" lazy-validation class="mt-5 col-sm-8 col-md-8">

                    <v-text-field :label="'*'+$t('companies.label.company.title')" :placeholder="$t('companies.label.company.text')" 
                        color="secondary" :counter="40" :maxlength="40" required :rules="companyNameRules" v-model="formData.companyName"></v-text-field>

                    <v-select :label="'*'+$t('label.typeIdentification.title')" :placeholder="$t('label.typeIdentification.text')" 
                        color="secondary" required :items="typeIdentification" item-text="identificationType" item-value="identificationId" 
                        :rules="typeIdentificationRules" v-model="formData.identificationId"></v-select>

                    <v-text-field :label="'*'+$t('label.numIdentification.title')" :placeholder="$t('label.numIdentification.text')" 
                        color=secondary required :counter="19" :maxlength="19" :rules="identificationNumberRules" v-model="formData.identificationNumber"
                        @input="formatIdentificationNumber" @keydown="handleKeyDown" inputmode="numeric"></v-text-field>

                    <v-text-field :label="'*'+$t('companies.label.nameContact.title')" :placeholder="$t('companies.label.nameContact.text')"
                        color=secondary :counter="100" :maxlength="100" required :rules="contactNameRules" v-model="formData.contactName"></v-text-field>

                    <v-text-field :label="'*'+$t('label.phone.title')" :placeholder="$t('label.phone.text')"
                        color="secondary" required :rules="phoneRules" v-model="formData.contactNumber"
                        @keydown="handleKeyPhoneDown" inputmode="numeric" pattern="[0-9]{0,15}" :counter="15" :maxlength="15"></v-text-field>

                    <v-text-field :label="'*'+$t('label.email.title')" :placeholder="$t('label.email.text')" 
                        color=secondary required :rules="emailRules" :counter="200" :maxlength="200" v-model="formData.email"></v-text-field>

                    <v-select :label="'*'+$t('companies.label.monetization.title')" :placeholder="$t('companies.label.monetization.text')" 
                        class="text-subtitle-1" color="secondary" required multiple chips small-chips :items="monetizationTypes" item-text="name" 
                        item-value="monetizationId" v-model="formData.monetizationTypes" :rules="monetizationTypesRules">

                        <template v-slot:selection="{ item, index }">
                            <v-chip close @click:close="removeMonetizationType(index)" small class="ma-1">
                                {{ item.name }}
                            </v-chip>
                        </template>

                    </v-select>

                    <v-text-field :label="'*'+$t('companies.label.valueAffiliate.title')" :placeholder="$t('companies.label.valueAffiliate.text')" color="primary"
                        required v-model="formData.afiliateFee" @keydown="handleKeyDown" @blur="handleBlur" type="text" :rules="valorTarifaAfiliadoRules" clearable></v-text-field>

                    <v-text-field :label="$t('companies.label.monthlyCutoffDay.title')" :placeholder="$t('companies.label.monthlyCutoffDay.text')" color="primary"
                        v-model.number="formData.monthlyCutoffDay" type="number" min="1" max="31" :rules="monthlyCutoffDayRules" clearable></v-text-field>

                    <v-select
                        label="Tipo de empresa demo"
                        placeholder="Seleccione un tipo"
                        color="secondary"
                        :items="companyDemoTypes"
                        item-text="name"
                        item-value="id"
                        clearable
                        v-model="formData.idTipoEmpresaDemo"
                    ></v-select>
                </v-form>

                <div class="image-container">
                    <div>
                        <changeImage :image="imageFile" />
                    </div>
                    <div class="img-btn">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>{{ $t('label.image.text') }}</span>
                        </v-tooltip>

                        <input type="file" @change="onFileChange" id="file-input" accept="image/*"
                            style="display: none" />

                        <v-tooltip left>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on"
                                    @click="submitForm">
                                    <v-icon dark>mdi-content-save</v-icon>
                                </v-btn>

                            </template>

                            <span>{{ $t('button.save') }}</span>

                        </v-tooltip>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import changeImage from "@/shared/components/change_image/change_image_component.vue";

import {
    COMPANIES_M,
    GET_COMPANIES_LIST_TYPE_DOCUMENT,
    ACTION_POST_CREATE_COMPANIES,
    ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT,
    ACTION_GET_ALL_MONETIZATION_TYPES,
    GET_STATE_LOADING,
    GET_ALL_MONETIZATION_TYPES,
    GET_COMPANY_DEMO_TYPES,
    ACTION_GET_COMPANY_DEMO_TYPES
} from "@/views/companies/store/types/types.js";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {

    components: {
        changeImage,
    },
    name: "addCompaniesComponent",

    data() {
        return {
            formData: {
                companyName: null,
                identificationId: 6,
                identificationNumber: null,
                contactName: null,
                contactNumber: null,
                email: null,
                imageFile: null,
                monetizationTypes:[],
                afiliateFee: null,
                monthlyCutoffDay: null,
                idTipoEmpresaDemo: null,
            },
            imageFile: null, // Estado local para almacenar la URL de la imagen seleccionada
            allowedImageTypes: [
                "image/jpeg",
                "image/png",
                "image/jpg",
                "image/svg+xml",
            ],
            companyNameRules: [
                v => !!v || this.$t('companies.label.nameCompany.required')
            ],
            typeIdentificationRules: [
                v => !!v || this.$t('label.typeIdentification.required')
            ],
            identificationNumberRules: [
                v => !!v || this.$t('label.numIdentification.required')
            ],
            contactNameRules: [
                v => !!v || this.$t('companies.label.nameContact.required')
            ],
            phoneRules: [
                v => !!v || this.$t('label.phone.required'),
                v => (v && v.length >= 7 && v.length <= 15) || this.$t('label.phone.maxLength')
            ],
            emailRules: [
                v => !!v || this.$t('label.email.required'),
                v => emailRegex.test(v) || this.$t('label.email.invalid')
            ],
            monetizationTypesRules: [
                v => (v && v.length > 0) || this.$t('companies.label.monetization.required')
            ],
            valorTarifaAfiliadoRules: [
                v => !!v || this.$t('companies.label.valueAffiliate.required'),
                v => parseFloat(v.replace(/[$,]/g, '')) > 0 || this.$t('companies.label.valueAffiliate.minLength')
            ],
            monthlyCutoffDayRules: [
                v => !v || (v >= 1 && v <= 31) || this.$t('companies.label.monthlyCutoffDay.range')
            ],

            showErrorMessages: false,
            emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
        };
    },

    async mounted() {

        this.getActionTypeIdentification();
        this.getActionMonetizaationType(0);
        this.getActionCompanyDemoTypes();
        // Escuchar evento para limpiar el formulario cuando el diálogo se cierra
        EventBus.$on('clear-companies-form', this.clearForm);
    },
        
    beforeDestroy() {
        // Limpiar el event listener
        EventBus.$off('clear-companies-form', this.clearForm);
    },
    computed: {
        ...mapGetters({
            loading: [`${COMPANIES_M}${GET_STATE_LOADING}`],
            typeIdentification: [`${COMPANIES_M}${GET_COMPANIES_LIST_TYPE_DOCUMENT}`],
            monetizationTypes: [`${COMPANIES_M}${GET_ALL_MONETIZATION_TYPES}`],
            companyDemoTypes: [`${COMPANIES_M}${GET_COMPANY_DEMO_TYPES}`]
        }),

        // Propiedad computada para convertir formData.urlImagenEmpresa en imageUrl
        imageUrl() {
            return this.formData.imageFile;
        },
    },

    methods: {
        ...mapActions({
            postActionCrearCompany: `${COMPANIES_M}${ACTION_POST_CREATE_COMPANIES}`,
            getActionTypeIdentification: `${COMPANIES_M}${ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT}`,
            getActionMonetizaationType: `${COMPANIES_M}${ACTION_GET_ALL_MONETIZATION_TYPES}`,
            getActionCompanyDemoTypes: `${COMPANIES_M}${ACTION_GET_COMPANY_DEMO_TYPES}`
        }),

        removeMonetizationType(index) {
            this.formData.monetizationTypes.splice(index, 1);
        },

        clearForm() {
            // Resetear formData
            this.formData = {
                companyName: null,
                identificationId: 6,
                identificationNumber: null,
                contactName: null,
                contactNumber: null,
                email: null,
                imageFile: null,
                monetizationTypes: [],
                afiliateFee: null,
                monthlyCutoffDay: null,
                idTipoEmpresaDemo: null,
            };
            
            // Resetear imagen local
            this.imageFile = null;
            
            // Resetear validación del formulario
            if (this.$refs.form) {
                this.$refs.form.reset();
            }
            
            // Resetear input de archivo
            const fileInput = document.getElementById('file-input');
            if (fileInput) {
                fileInput.value = '';
            }
        },

        handleKeyDown(event) {
            // Permite solo números y la tecla de borrar
            if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },

        handleBlur() {
            if (this.formData.afiliateFee) {
                const numberValue = parseFloat(this.formData.afiliateFee.replace(/[^0-9.]/g, ''));
                if (!isNaN(numberValue)) {
                    this.formData.afiliateFee = this.formatNumber(numberValue);
                } else {
                    this.formData.afiliateFee = '';
                }
            }
        },

        formatNumber(value) {
            return '$' + parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        handleKeyPhoneDown(event) {
            const allowedKeys = /^[0-9()-]$/; // Expresión regular que permite números, espacios, paréntesis y guiones medios

            // Permitir solo las teclas que coinciden con la expresión regular o la tecla de borrar
            if (!allowedKeys.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },

        // Método para manejar el cambio de archivo
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                // Asignar el archivo de imagen seleccionado a formData.imageFile
                this.formData.imageFile = file;

                // Leer la URL de la imagen seleccionada y actualizar imageFile si es necesario
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageFile = e.target.result; // Actualizar la URL de la imagen seleccionada
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.imageFile.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.invalid.title'),
                    text: i18n.t('label.image.invalid')
                });
            }
        },

        validatePercentage(value) {
            if (!value) {
                return false;
            }

            const numericValueStr = value.toString().replace(',', '.');

            if (numericValueStr.endsWith('.')) {
                return false;
            }

            if (numericValueStr.startsWith('.')) {
                return false;
            }

            if (numericValueStr.split('.').length - 1 > 1) {
                return false;
            }

            const parts = numericValueStr.split('.');
            const decimalPart = parts[1];

            if (decimalPart && decimalPart.length > 2) {
                return false;
            }

            const numericValue = parseFloat(numericValueStr);
            return numericValue >= 1 && numericValue <= 10;
        },

        async submitForm() {
            try {
                const result = await Swal.fire({
                    title: i18n.t('label.confirm.title'),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: i18n.t('button.save.text'),
                    cancelButtonText: i18n.t('button.cancel.text'),
                    confirmButtonColor: '#6E17A5'

                });
                if (result.isConfirmed) {

                    // Validar el formulario antes de enviarlo
                    const validationErrors = this.validateForm();

                    // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.errorsValidation.plural.title'),
                            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }

                    this.formData.monetizationTypes = this.formData.monetizationTypes
                        .filter(id => typeof id === 'number' || !isNaN(parseInt(id)))
                        .map(id => parseInt(id));
                    
                    // Si no hay errores de validación, imprime el formulario en la consola
                    const save = await this.postActionCrearCompany(this.formData);
                    if (!save) {
                        return Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.invalid.title'),
                            text: i18n.t('label.invalid.text')
                        })
                    }

                    await this.clearForm();
                    EventBus.$emit('formCompany-submitted-successfully');

                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: i18n.t('label.delete.cancel'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                }

            } catch (error) {
                console.error(i18n.t('label.failService'), error);
            }
        },

        formatIdentificationNumber() {
            // Eliminar puntos y espacios del número de identificación actual
            let number = this.formData.identificationNumber.replace(/[^\d]/g, '');

            // Formatear el número con puntos de unidades, decenas, centenas, etc.
            let formattedNumber = '';
            while (number.length > 0) {
                // Agregar los últimos tres dígitos al principio del número formateado
                formattedNumber = number.slice(-3) + formattedNumber;

                // Quitar los últimos tres dígitos del número
                number = number.slice(0, -3);

                // Si todavía quedan dígitos, agregar un punto al principio del número formateado
                if (number.length > 0) {
                    formattedNumber = '.' + formattedNumber;
                }
            }

            // Asignar el número formateado de vuelta al campo de texto
            this.formData.identificationNumber = formattedNumber;
        },


        validateForm() {
            this.showErrorMessages = true;

            // Expresión regular para validar que no consista solo en espacios en blanco o tabulaciones
            const notOnlyWhitespaceRegex = /\S/;
            const errors = {};

            if (!this.formData.companyName || !this.formData.companyName.trim() || this.formData.companyName.length > 40) {
                errors.companyName = this.$t('companies.label.company.title');
            }

            if (!this.formData.identificationId) {
                errors.identificationId = this.$t('label.typeIdentification.title');
            }

            if (!this.formData.identificationNumber || !this.formData.identificationNumber.trim() || this.formData.identificationNumber.length > 19) {
                errors.identificationNumber = this.$t('label.numIdentification.title');
            }

            if (!this.formData.contactName || !notOnlyWhitespaceRegex.test(this.formData.contactName) || this.formData.contactName.length > 100) {
                errors.contactName = this.$t('companies.label.nameContact.title');
            }

            if (!this.formData.contactNumber || !/^[0-9]{7,15}$/.test(this.formData.contactNumber)) {
                errors.contactNumber = this.$t('label.phone.title');
            }

            if (!this.formData.email || !emailRegex.test(this.formData.email) || this.formData.email.length > 200) {
                errors.email = this.$t('label.email.title');
            }

            if (!Array.isArray(this.formData.monetizationTypes) || this.formData.monetizationTypes.length === 0) {
                errors.monetizationTypes = this.$t('companies.label.monetization.title');
            }

            if (!this.formData.afiliateFee || this.formData.afiliateFee === '$0.00') {
                errors.afiliateFee = this.$t('companies.label.valueAffiliate.title');
            }

            if (!this.formData.imageFile) {
                errors.imageFile = this.$t('companies.label.imageCompany');
            }

            if (this.formData.monthlyCutoffDay !== null && (this.formData.monthlyCutoffDay < 1 || this.formData.monthlyCutoffDay > 31)) {
                errors.monthlyCutoffDay = this.$t('companies.label.monthlyCutoffDay.range');
            }

            return errors;
        },
    },
};

</script>


<style lang="css" scoped>
/* Css input imagen*/

.col-md-7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 230px;
}

.row {
    display: flex;
    justify-content: center;
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.img-btn {
    margin-top: 20px;
}

.user-btn {
    position: absolute;
    top: 20px;
    right: 20px;
}

/*Resposive*/

@media screen and (max-width: 912px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 820px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 768px) {
    .col-md-7 {
        gap: 40px;
    }

    .image-container {
        margin-bottom: 20px;
    }
}

@media screen and (max-width: 425px) {
    .col-md-7 {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }
}


/* Para pantallas muy pequeñas */
@media screen and (max-width: 425px) {
    .col-md-7 {
        flex-direction: column;
        align-items: center;
    }

    .image-container {
        margin-bottom: 20px;
    }

    .user-btn {
        position: static;
        margin-top: 20px;
    }
}
</style>